import {
  HicapsConnectExtendedDataTypeGuard,
  IHicapsConnectMedicareClaimTransactionExtendedData,
  TransactionStatus,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../../transaction-action';
import { TransactionHelpers } from '../../../transaction-helpers';

export class VoidHicapsConnectMedicareTransaction
  implements
    ITransactionAction<IHicapsConnectMedicareClaimTransactionExtendedData>
{
  icon = 'block';
  label = 'Void';
  tooltip = 'Void if claim has been manually cancelled via Medicare';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = HicapsConnectExtendedDataTypeGuard.isMedicareClaim;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IHicapsConnectMedicareClaimTransactionExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      HicapsConnectExtendedDataTypeGuard.isMedicareClaim
    ).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return (
          transaction.type === TransactionType.Incoming &&
          transaction.status !== TransactionStatus.Failed
        );
      })
    );
  }

  async do(
    data: ITransactionActionsData<IHicapsConnectMedicareClaimTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.cancel(
      data.invoice,
      data.latestTransaction,
      'Void Medicare Claim'
    );
    this.inProgress$.next(false);
  }
}
